import axios from "axios";
import Cookies from "js-cookie";

axios.defaults.withCredentials = true;

const trim = (s) => (s ? String(s).replace(/\/+$/, "") : "");
const isDev = import.meta.env?.DEV || import.meta.env?.MODE === "development";
const useFrontendProxy = (url) => {
  const value = trim(url);
  const proxyTarget = trim(import.meta.env.VITE_DEV_PROXY_TARGET);
  if (!isDev || !proxyTarget || value !== proxyTarget) return value;
  return "";
};
const envUrl = (key) => useFrontendProxy(import.meta.env[key]);
const DEFAULT_GATEWAY = envUrl("VITE_GATEWAY_URL") || "";
export const BASE_URLS = {
  GATEWAY: envUrl("VITE_GATEWAY_URL") || DEFAULT_GATEWAY,

  USERS: envUrl("VITE_USER_SERVICE_URL") || `${DEFAULT_GATEWAY}/users`,
  MEDICAL:
    trim(import.meta.env.VITE_MEDICAL_SERVICE_URL) ||
    `${DEFAULT_GATEWAY}/medical-information`,
  CYCLES: trim(import.meta.env.VITE_CYCLE_SERVICE_URL) || `${DEFAULT_GATEWAY}/cycles`,
  RELATIVES:
    trim(import.meta.env.VITE_RELATIVES_SERVICE_URL) ||
    `${DEFAULT_GATEWAY}/relatives`,

  AUTH: envUrl("VITE_MS_AUTH") || DEFAULT_GATEWAY,

  POSTS: trim(import.meta.env.VITE_MS_POSTS) || `${DEFAULT_GATEWAY}/posts`,
  LIKES: trim(import.meta.env.VITE_LIKES_SERVICE_URL) || `${DEFAULT_GATEWAY}/likes`,
  COMMENTS:
    trim(import.meta.env.VITE_COMMENTS_SERVICE_URL) || `${DEFAULT_GATEWAY}/comments`,

  MEDICATION:
    trim(import.meta.env.VITE_MEDICATIONS_SERVICE_URL) || `${DEFAULT_GATEWAY}/medication`,
  MEDICATIONS_DATABASE:
    trim(import.meta.env.VITE_MEDICATIONS_DATABASE_SERVICE_URL) || DEFAULT_GATEWAY,
  ANALYSE: trim(import.meta.env.VITE_MS_ANALYSE) || `${DEFAULT_GATEWAY}/analyse`,
  SIGNAL: trim(import.meta.env.VITE_MS_SIGNAL) || `${DEFAULT_GATEWAY}/signal`,

  PRESCRIPTION: trim(import.meta.env.VITE_MS_PRESCRIPTION) || `${DEFAULT_GATEWAY}`,

  EMERGENCY:
    trim(import.meta.env.VITE_EMERGENCYCONTACT_SERVICE_URL) ||
    `${DEFAULT_GATEWAY}/emergency-contact`,

  PLACES: trim(import.meta.env.VITE_MS_PLACES) || `${DEFAULT_GATEWAY}/places`,
  MESSAGES:
    trim(import.meta.env.VITE_MESSAGES_SERVICE_URL) || `${DEFAULT_GATEWAY}/messages`,

  REGISTER_DOCTOR:
    envUrl("VITE_REGISTERDOCTOR_URL") || `${DEFAULT_GATEWAY}/register-doctors`,

  DOCTOR_AUTH: envUrl("VITE_LOGINDOCTOR_URL") || `${DEFAULT_GATEWAY}/auth`,

  DISPONIBILITY:
    trim(import.meta.env.VITE_AVAILABILITY_SERVICE_URL) || `${DEFAULT_GATEWAY}/disponibilite`,
  
  DOCTORPROFILE:
    trim(import.meta.env.VITE_DOCTORPROFILE_SERVICE_URL) ||
    `${DEFAULT_GATEWAY}/doctor-profiles`,

  RDV: trim(import.meta.env.VITE_RDV_SERVICE_URL) || `${DEFAULT_GATEWAY}/rendezvous`,

  HEALTHBOT: trim(import.meta.env.VITE_MEDICAL_ASSISTANT_PATH) || DEFAULT_GATEWAY,

  EXTRACTION:
    trim(import.meta.env.VITE_EXTRACTION_SERVICE_URL) || `${DEFAULT_GATEWAY}/extraction`,

  EVENTS: trim(import.meta.env.VITE_EVENTS_SERVICE_URL) || `${DEFAULT_GATEWAY}/events`,

  VITALS: trim(import.meta.env.VITE_VITALS_SERVICE_URL) || `${DEFAULT_GATEWAY}/vital-signs`,
  MODERATION:
    trim(import.meta.env.VITE_MODERATION_SERVICE_URL) || `${DEFAULT_GATEWAY}/moderation`,
  DOCTORS: trim(import.meta.env.VITE_DOCTORS_SERVICE_URL) || `${DEFAULT_GATEWAY}/doctors`,

  CONSULTATION:
    trim(import.meta.env.VITE_CONSULTATION_SERVICE_URL) || `${DEFAULT_GATEWAY}/consultations`,

  NOTIFICATIONS:
    trim(import.meta.env.VITE_NOTIFICATION_SERVICE_URL) || `${DEFAULT_GATEWAY}/notifications`,

  FOLLOWS: trim(import.meta.env.VITE_FOLLOWS_SERVICE_URL) || `${DEFAULT_GATEWAY}/follows`,

  CONNECTIONS:
    trim(import.meta.env.VITE_CONNECTIONS_SERVICE_URL) ||
    `${DEFAULT_GATEWAY}/connections`,
  
  INTERRACTION:
  trim(import.meta.env.VITE_INTERRACTION_SERVICE_URL) ||
  `${DEFAULT_GATEWAY}`,
};


const ensureSuffix = (key, suffix) => {
  const val = BASE_URLS[key];
  if (!val) return;
  const clean = trim(val);
  if (clean.endsWith(suffix)) {
    BASE_URLS[key] = clean;
    return;
  }
  BASE_URLS[key] = `${clean}${suffix.startsWith("/") ? "" : "/"}${suffix}`;
};

ensureSuffix("DOCTORPROFILE", "/doctor-profiles");
ensureSuffix("NOTIFICATIONS", "/notifications");
ensureSuffix("FOLLOWS", "/follows");
ensureSuffix("CONNECTIONS", "/connections");


const getDoctorToken = () =>
  Cookies.get("doctorAccessToken") ||
  Cookies.get("doctor_token") ||
  Cookies.get("doctorToken") ||
  Cookies.get("doctorJwt") ||
  localStorage.getItem("doctorAccessToken") ||
  localStorage.getItem("doctor_token") ||
  localStorage.getItem("doctorToken") ||
  localStorage.getItem("doctorJwt") ||
  null;

const attachAuthHeader = (config) => {
  config.headers = config.headers || {};
  if (config.headers.Authorization || config.headers.authorization) {
    return config;
  }

  const doctorToken = getDoctorToken();
  const patientToken =
    Cookies.get("accessToken") ||
    Cookies.get("auth_token") ||
    Cookies.get("token") ||
    localStorage.getItem("patientAccessToken") ||
    sessionStorage.getItem("patientAccessToken") ||
    null;

  const activeRole =
    window.sessionStorage.getItem("activeSessionRole") ||
    localStorage.getItem("userRole") ||
    null;

  const token =
    activeRole === "patient"
      ? patientToken || doctorToken
      : doctorToken || patientToken;

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
};

const createInstance = (baseURL, options = {}) => {
  const opts = typeof options === "string" ? { serviceName: options } : options;

  const instance = axios.create({
    baseURL: baseURL || BASE_URLS.GATEWAY || "",
    withCredentials: true,
    headers: { "Content-Type": "application/json" },
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    ...opts.axiosOptions,
  });
  instance.interceptors.request.use(attachAuthHeader, (err) => Promise.reject(err));

  if (isDev && opts.enableDevLogging !== false) {
    const serviceName = opts.serviceName || "API";

    instance.interceptors.request.use((cfg) => {
      return cfg;
    });

    instance.interceptors.response.use(
      (res) => {
        return res;
      },
      (err) => {
        console.warn(
          `[${serviceName} ✗]`,
          err?.response?.status,
          (err?.config?.baseURL || "") + (err?.config?.url || ""),
          err?.response?.data ?? err?.message
        );
        return Promise.reject(err);
      }
    );
  }

  return instance;
};

export const axiosAuth = createInstance(BASE_URLS.AUTH, { serviceName: "auth" });
export const axiosPosts = createInstance(BASE_URLS.POSTS, { serviceName: "posts" });
export const axiosComments = createInstance(BASE_URLS.COMMENTS, { serviceName: "comments" });
export const axiosLikes = createInstance(BASE_URLS.LIKES, { serviceName: "likes" });
export const axiosMedication = createInstance(BASE_URLS.MEDICATION, { serviceName: "medication" });
export const axiosMedicationsDatabase = createInstance(BASE_URLS.MEDICATIONS_DATABASE, { serviceName: "medicationsDatabase" });
export const axiosAnalyse = createInstance(BASE_URLS.ANALYSE, { serviceName: "analyse" });
export const axiosSignal = createInstance(BASE_URLS.SIGNAL, { serviceName: "signal" });
export const axiosPrescription = createInstance(BASE_URLS.PRESCRIPTION, { serviceName: "prescription" });
export const axiosEmergency = createInstance(BASE_URLS.EMERGENCY, { serviceName: "emergency" });
export const axiosPlaces = createInstance(BASE_URLS.PLACES, { serviceName: "places" });
export const axiosGateway = createInstance(BASE_URLS.GATEWAY, { serviceName: "gateway" });
export const axiosUsers = createInstance(BASE_URLS.USERS, { serviceName: "users" });
export const axiosMedical = createInstance(BASE_URLS.MEDICAL, { serviceName: "medical" });
export const axiosRelatives = createInstance(BASE_URLS.RELATIVES, { serviceName: "relatives" });
export const axiosCycles = createInstance(BASE_URLS.CYCLES, { serviceName: "cycles" });
export const axiosVitals = createInstance(BASE_URLS.VITALS, { serviceName: "vitals" });
export const axiosModeration = createInstance(BASE_URLS.MODERATION, { serviceName: "moderation" });
export const axiosMessages = createInstance(BASE_URLS.MESSAGES, { serviceName: "messages" });
export const axiosDoctorRegister = createInstance(BASE_URLS.REGISTER_DOCTOR, { serviceName: "doctorRegister" });
export const axiosDoctorAuth = createInstance(BASE_URLS.DOCTOR_AUTH, { serviceName: "doctorAuth" });
export const axiosDoctors = createInstance(BASE_URLS.DOCTORS, { serviceName: "doctors" });
export const axiosExtraction = createInstance(BASE_URLS.EXTRACTION, { serviceName: "extraction" });
export const axiosDisponibility = createInstance(BASE_URLS.DISPONIBILITY, { serviceName: "disponibility" });
export const axiosRDV = createInstance(BASE_URLS.RDV, { serviceName: "rdv" });
export const axiosDoctorProfile = createInstance(BASE_URLS.DOCTORPROFILE, { serviceName: "doctorProfile" });
export const axiosAssistant = createInstance(BASE_URLS.GATEWAY, { serviceName: "assistant" });
export const axiosHealthBot = createInstance(BASE_URLS.HEALTHBOT, { serviceName: "healthBot" });
export const axiosConsultation = createInstance(BASE_URLS.CONSULTATION, { serviceName: "consultation" });
export const axiosEvents = createInstance(BASE_URLS.EVENTS, { serviceName: "events" });
export const axiosNotifications = createInstance(BASE_URLS.NOTIFICATIONS, { serviceName: "notifications" });
export const axiosFollows = createInstance(BASE_URLS.FOLLOWS, { serviceName: "follows" });
export const axiosConnections = createInstance(BASE_URLS.CONNECTIONS, { serviceName: "connections" });
export const axiosInterraction = createInstance(BASE_URLS.INTERRACTION, { serviceName: "interraction" });
export const SOCKET_URL = BASE_URLS.GATEWAY;

export const api = axiosGateway;
export default api;
